<template>
<div>
    <b-row>
    <b-col>
        <SelectList 
           id="dates"
            :options="dateOptions"  
            @select="onSelectDate" 
            :searchable="false" 
            :clearable="false" 
            :disabled="loading"
            :value="date" /> 
    </b-col>
    <b-col style="text-align: right">
        <SelectList 
            id="reload" 
            :options="reloadOptions"
            @select="onSelectReloadInterval" 
            :searchable="false" 
            :clearable="false" 
            :disabled="loading"  
            :value="reloadInterval" /> 

    </b-col>
    </b-row>

    <b-table 
        v-if="departures.length > 0"
        small
        sticky-header
        selectable
        primary-key='index'
        select-mode="single"
        :items="departures" 
        :fields="fields"
        :busy="loading"
        tbody-tr-class="departure-row" 
        ref="departureTable" 
        id='departures'
        class="departures">

        <template v-slot:cell(estimateTime)="data">
            <div v-if="data.item.passingCanceled"><b-icon icon="exclamation-triangle-fill" scale='1.2' style="margin-right: 6px"/>{{ $t('timetables.canceled') }}</div>
            <div v-if="data.item.status == -2"><b-icon variant="dark" icon="x" scale='2' style="margin-right: 6px"/>{{ $t('timetables.removed') }}</div>
            <div v-else> 
                <div>{{ getTime(data.item.estimateTime) }}</div>
                <div v-if="$UIPrivilege('content/timetables', 'departures.status') && data.item.status != 0" class='status'>{{ $t('timetables.status.' + data.item.status) }}</div>
            </div>
        </template>

        <template v-slot:cell(destination)="data">
            <div>{{ data.item.destination }}</div>
            <div v-if="getVia(data.item)" class='via'>{{ getVia(data.item) }}</div>
        </template>

        <template v-slot:cell(stop)="data">
            <div v-if="data.item.stopSms">
                <div>{{ data.item.stop }}</div>
                <div class='via'><span>{{ data.item.stopSms }}</span>  <span v-if="data.item.platform">{{ data.item.platform }}</span></div>
            </div>
            <div v-else>
                 <div>{{ data.item.stop }} <span v-if="data.item.platform" class='via'>{{ data.item.platform }}</span></div>
            </div>
        </template>

        <template v-slot:cell(vehicle)="data">
            <VehicleBrief 
                :label="data.item.vehicle"
                :showVehicleOnMap="showLinkToVehicleOnMap()"
                sizeClass="h3"
                >
            </VehicleBrief>
        </template>
    </b-table> 
    <span v-if="!loading && departures.length == 0" class="info note">{{ $t('timetables.no_departures') }}</span>
    <RequestInfo :loader="loading" />
</div>
</template>

<script>
import VehicleBrief from '@/components/Realtime/VehicleBrief'
//import timeUtil from '@/util/timeUtils.js'
import moment from 'moment'

export default {
    components: {VehicleBrief},
    props: {
        item: { default: null },
        count: { default: 10 }
    },
    data() {
        return {
            /*
            fields: [
                { key: "passingTime", label: this.$t("timetables.labels.passing_time"), formatter: 'getTime', tdClass: 'time' },
                { key: "estimateTime", label: this.$t("timetables.labels.estimate_time"),  tdClass: 'rt'},
                { key: "lineLabel", label: this.$t("timetables.labels.line"), tdClass: 'line' },
                { key: "destination", label: this.$t("timetables.labels.destination"),  tdClass: 'dest'},
                { key: "vehicle", label: this.$t("timetables.labels.vehicle")},
            ],
            */
            departures: [],
            departureUpdater: null,
            loading: false,
            date: null,
            dates: [],
            autoUpdate: true,
            reloadOptions: [
                { id: 0, label: this.$t("timetables.reload.0"), icon: "dash" },
                { id: 10, label: this.$t("timetables.reload.10"), icon: "arrow-clockwise" },
                { id: 30, label: this.$t("timetables.reload.30"), icon: "arrow-clockwise" },
                { id: 60, label: this.$t("timetables.reload.60"), icon: "arrow-clockwise" }
            ],
            reloadInterval: 60
        }
    },
    computed: {
        dateOptions(){
            var options = [];
            
            for(var d of this.dates){
               options.push( { id: d, label: d, icon: "calendar2-date" } );                
            }
            return options;
        },
        fields(){
            var cols = []; 
            cols.push( { key: "passingTime", label: this.$t("timetables.labels.passing_time"), formatter: 'getTime', tdClass: 'time' } );
            cols.push( { key: "estimateTime", label: this.$t("timetables.labels.estimate_time"),  tdClass: 'rt'} );
            cols.push( { key: "lineLabel", label: this.$t("timetables.labels.line"), tdClass: 'line' } );
            cols.push( { key: "destination", label: this.$t("timetables.labels.destination"),  tdClass: 'dest'} );
            cols.push( { key: "stop", label: this.$t("timetables.labels.stop"), tdClass: 'stop'} );

            // privilege / setting to enable/disable ? 
            cols.push( { key: "vehicle", label: this.$t("timetables.labels.vehicle"), thClass: 'vehicle' , tdClass: 'vehicle' } );

            return cols;
        }

    },
    beforeDestroy(){
        clearTimeout(this.departureUpdater);
    },
    watch: {
        item(){
            this.dates = [];
            this.getDepartureDates();
 
            this.departures = [];
            this.updateDepartures();
            this.autoUpdate = true;
        },
        date(){
            this.departures = [];
            this.updateDepartures();
            this.autoUpdate = true;
        },
        
        autoUpdate(){
            if(this.autoUpdate)
                this.updateDepartures();
            else{
                clearTimeout(this.departureUpdater);
            }
        },
        reloadInterval(){
            if(this.reloadInterval == 0){
                clearTimeout(this.departureUpdater);
            }
            else {
                this.updateDepartures();
            }
        }
        

    },
    created(){
        this.date = moment().format("YYYY-MM-DD");  

        this.getDepartureDates();
        this.updateDepartures();
    },
    methods: {
        showLinkToVehicleOnMap() {
			return this.$UiConfig('/ui/actions/showLinkToVehicleOnMap', true)
		},
        getDepartureDates(){
            this.$traveller_http.get('/traveller/restui/content/timetableview/departureDates', { params: { "id": this.item.id} })
            .then( response => {
                this.dates = response.data;
            })
            .catch( () => {} ) 
            .finally( () => { /*this.loading = false;*/ } ); 
        },
        updateDepartures(){
          
            clearTimeout(this.departureUpdater);

            //alert("#" + this.autoUpdate);
            if( !this.item || this.loading /* || !this.autoUpdate */) {
                return;
            }
           this.loading = true;
            
           const start = moment(this.date).startOf('day');
           const end = moment(this.date).endOf('day');
            
            const params = { 
                params: {
                    "id" : this.item.id,
                    "start": start.format(),
                    "end" : end.format()
                }
            }

            //const $vm = this;
            this.$traveller_http.get('/traveller/restui/content/timetableview/departuresBetween', params )
            .then(response => {
                let sorted = response.data.sort((a, b) => {
                    if (a.passingTime && b.passingTime) {
                        const timeA = new Date(a.passingTime).getTime();
                        const timeB = new Date(b.passingTime).getTime();
                        return timeA - timeB;
                    }

                    return 0;                
                });
                
                this.departures = sorted;
                
                let currentDate = moment().format("YYYY-MM-DD");  

                // draw time indicator only if departures are for current day
                if(currentDate == this.date){
                    this.$nextTick(() => {
                        var table = document.getElementById("departures");
                        if(table){
                            let time = new Date().getTime();

                            // find next departure
                            let index = this.departures.findIndex(d => (d.passingTime > time || d.estimateTime > time) );

                            // scroll to current departures - reduced by 5 to see past departures
                            let show = index - 5; if(show < 0) show = 0;
                            //table.rows[show].scrollIntoView();
                        
                            let parent = table.parentElement;
                            let parentRect = parent.getBoundingClientRect();
                            let parentViewableArea = {
                                height: parent.clientHeight,
                                width: parent.clientWidth
                            };
                            var childRect = table.rows[show].getBoundingClientRect();
                            var isViewable = (childRect.top >= parentRect.top) && (childRect.top <= parentRect.top + parentViewableArea.height);
                            if (!isViewable) {
                                parent.scrollTop = (childRect.top + parent.scrollTop) - parentRect.top
                            }

                            // clear previous indicator classess
                            let clear = document.querySelectorAll('.next');
                            clear.forEach( e => { e.classList.remove("next"); } );
                            clear = document.querySelectorAll('.prev');
                            clear.forEach( e => { e.classList.remove("prev"); } );

                            // place indicator classes 
                            let next = index + 1; if(next < 0) next = 0;
                            table.rows[next].classList.add("next");
                            table.rows[next-1].classList.add("prev");
                        }
                    });   
                }


                // show vehicle column only if vehicle information is available
                let vehicleInformationFound = this.departures.find(d => d.vehicle ) != null;
                if(vehicleInformationFound){
                    let elems = document.querySelectorAll("#departures .vehicle");
                    elems.forEach( e => { e.style.display ="table-cell" } );
                }
            })
            .catch( () => {})
            .finally(() => {
                this.loading = false;
                if(this.reloadInterval > 0)
                    this.departureUpdater = setTimeout(this.updateDepartures, this.reloadInterval*1000);               
            });
            clearTimeout(this.departureUpdater);                     
            this.departureUpdater = setTimeout(this.updateDepartures, 30000);  
        },
        getTime(value){
            if(!value)
                return ""
            const date = new Date(value);
            const hours = date.getHours();
            let minutes = date.getMinutes();
            let seconds = date.getSeconds();
            if(minutes < 10) minutes = "0" + minutes;
           
           let time = hours + ":" + minutes;
           if(seconds > 0) {
                if(seconds < 10) seconds = "0" + seconds;
                time += ":" + seconds;
         }

            return time;
        },
        getVia(item){
            let via = "";
            
            if(item.intermediateDestinations){
                 for (let v of item.intermediateDestinations) {
                     via += v + " "; 
                 }
            }

            via = via.trim();

            const maxLength = 25;
            if(via.length > maxLength)
                via = via.slice(0, maxLength-1) + '...'

            return via;
        },
        onSelectDate(val){
            this.date = val;           
        },
        onCheck(check){
            // alert(check);
            this.autoUpdate = check;
        },
        
        onSelectReloadInterval(val){
            this.reloadInterval = val;
        }
    }
}

</script>

<style scoped lang="scss">
.departures {
    height: 75vh;
    max-height: 75vh;
}

#dates {
    width: 150px;
}

#reload {
    width: 120px;
    float: right;
}

</style>

<style lang="scss">
.departure-row {
    th.vehicle, td.vehicle {
        display: flex;
        align-items: center;
        white-space: nowrap;
    } 
}
</style>

